import { createSelector } from 'reselect'

export const usersState = (state) => state.users

export const usersSelectors = createSelector(usersState, (state) => state)
